import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './component/translation/i18n';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux'
import store from './redux/store';
import "./assets/css/theme_lightgreen.css";
import "./assets/css/theme_purple.css";
import "./assets/css/theme_amber.css";
import "./assets/css/theme_orange.css";
import "./assets/css/theme_pink.css";
import "./assets/css/theme_dark.css";
import "./assets/css/theme_royalblue.css";
import "./assets/css/theme_lightblue.css";
//import OfflineDbClass from './db'
import axios from 'axios';
import { createMuiTheme, makeStyles, ThemeProvider } from '@material-ui/core/styles';

const theme = createMuiTheme({
  typography: {
    fontFamily: [
      'IBM Plex Sans',
    ].join(','),
  },
});

const registerAxiosAuthHeaders = () => {
  axios.interceptors.request.use((config) => {
    const token = localStorage.getItem('BasicAuth')

    if (token) {
      config.headers.Authorization = `${token}`;
    }

    return config;
  });
};

const startApp = () => {
  ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </Provider>
    </React.StrictMode>,
    document.getElementById('root')
  );
  serviceWorker.register();
  registerAxiosAuthHeaders();
};

if(window.cordova) {
  document.addEventListener('deviceready', () =>{
    startApp()
    //alert(window.QRScanner)
    document.addEventListener('backbutton', function (evt) {
      if (window.cordova.platformId !== 'windows') {
          return;
      }
      if (!window.location.pathname.includes('home')) {
          window.history.back();
      } else {
          throw new Error('Exit'); // This will suspend the app
      }
    }, false);

    //window.plugins.preventscreenshot.disable((res)=>{}, (err)=>{})
    /*console.log(navigator.connection.type)
    document.addEventListener("offline", function(){
      alert(navigator.connection.type)
    }, false);
    document.addEventListener("online", function(){
      alert(navigator.connection.type)
    }, false);*/

  } , false);
} else {
  startApp();
  //OfflineDb.setDatabase();
}
/*
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();*/
